/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import { Storage } from '../storage/Storage';

export class CachingPolicy {
    static BodyInfoService = {
        storageType: Storage.StorageType.LOCAL_STORAGE,
        cachingDuration: 24 * 60 * 60 * 1000,
    };

    static ChannelsService = {
        storageType: Storage.StorageType.LOCAL_STORAGE,
        cachingDuration: 6 * 60 * 60 * 1000, // 6 hours
    };

    static StationPolicyService = {
        storageType: Storage.StorageType.LOCAL_STORAGE,
        cachingDuration: 24 * 60 * 60 * 1000,
    };

    static VPConfigurationsService = {
        storageType: Storage.StorageType.LOCAL_STORAGE,
        cachingDuration: 24 * 60 * 60 * 1000,
    };

    static InternalRatingsService = {
        storageType: Storage.StorageType.LOCAL_STORAGE,
        cachingDuration: 24 * 60 * 60 * 1000,
    };

    static IptvLoginService = {
        storageType: Storage.StorageType.LOCAL_STORAGE,
    };
}
